import React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App.jsx';
import './index.css';

/*
 * The site previously ran on HashRouter, so every link shared or bookmarked
 * before this release looks like https://chickrah.com/#/about.
 *
 * Fragments are never sent to the server, so nginx cannot 301 these — the
 * rewrite has to happen client side, before the router reads the URL.
 */
const { hash } = window.location;
if (hash.startsWith('#/')) {
  window.history.replaceState(null, '', hash.slice(1) || '/');
}

// Browsers restore the previous scroll position on refresh, which fights the
// per-route scroll-to-top in <ScrollToTop />.
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
